import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppsComponent } from './apps/apps.component';
import { UserComponent } from './user/user.component';
import { NotificationsComponent } from './notifications/notifications.component';

import {MatToolbarModule} from '@angular/material/toolbar';
import {MatRippleModule} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'src/app/shared/shared.module';
@NgModule({
    imports: [
        CommonModule,
        MatToolbarModule,
        MatRippleModule,
        MatCardModule,
        MatDividerModule,
        MatListModule,
        MatIconModule,
        MatButtonModule,
        SharedModule,
        AppsComponent, UserComponent, NotificationsComponent
    ],
    exports: [AppsComponent, UserComponent, NotificationsComponent]
})
export class MenusModule { }
